import { isPandaPanicEnabled, isPandaPanicOnlineEnabled } from '../games/panda-panic/flag';

const BRAND = 'RedPan';
// La home porte l'identité « officielle » du produit = le nom d'app configuré
// sur l'écran de consentement OAuth Google (« RedPanDev »). Google refuse la
// validation si le nom d'app ne correspond pas à celui de la page d'accueil.
const HOME_BRAND = 'RedPanDev';

/** Titre de document par route (spec 08 §4.5). */
export function titleFor(pathname: string): string {
  if (pathname === '/') return `${HOME_BRAND} — le repaire des jeux`;
  if (pathname === '/login') return `Connexion · ${BRAND}`;
  if (pathname === '/signup') return `Inscription · ${BRAND}`;
  if (pathname === '/profile') return `Mon profil · ${BRAND}`;
  if (pathname.startsWith('/u/')) {
    const name = decodeURIComponent(pathname.slice('/u/'.length));
    return name ? `Profil de ${name} · ${BRAND}` : BRAND;
  }
  if (pathname === '/settings' || pathname === '/settings/account') {
    return `Pseudo & avatar · ${BRAND}`;
  }
  if (pathname === '/settings/friends') return `Mes amis · ${BRAND}`;
  if (pathname === '/settings/security') return `Sécurité du compte · ${BRAND}`;
  if (pathname === '/settings/emails') return `Emails · ${BRAND}`;
  if (pathname === '/verify-email') return `Vérification d'email · ${BRAND}`;
  if (pathname === '/forgot-password') return `Mot de passe oublié · ${BRAND}`;
  if (pathname === '/reset-password') return `Nouveau mot de passe · ${BRAND}`;
  if (pathname === '/email/unsubscribe') return `Désabonnement · ${BRAND}`;
  if (pathname.startsWith('/motus-daily')) return `Motus du jour · ${BRAND}`;
  if (pathname.startsWith('/motus')) return `Motus duel · ${BRAND}`;
  if (pathname.startsWith('/griffonne')) return `Griffonne · ${BRAND}`;
  // Routes gatées (spec 15 §5 / §12.4) : flag off ⇒ la route n'est pas enregistrée,
  // c'est un vrai 404 (fallback conservé). Sous-routes online prises en compte
  // (le lobby `/panda-panic/online` et ses écrans) — sinon leur titre retombait à
  // tort sur « Page introuvable » alors que le jeu s'affiche.
  if (pathname === '/panda-panic' && isPandaPanicEnabled()) return `Panda Panic · ${BRAND}`;
  if (pathname.startsWith('/panda-panic/online') && isPandaPanicOnlineEnabled()) {
    return `Panda Panic en ligne · ${BRAND}`;
  }
  return `Page introuvable · ${BRAND}`;
}
